import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { SchoolProfileGroupType } from '@modules/types/graphql';
import { SchoolProfileSectionEntityList } from './school-profile-section-entity-list';

import type { SchoolProfileGroup } from '@modules/types/graphql';
import type { SchoolProfileSectionEntity } from './school-profile-section-entity';

export type Entity = Partial<SchoolProfileGroup> | null;

@DecribeEntity('SchoolProfileGroupEntity')
class SchoolProfileGroupEntity extends BaseEntity {
    type: SchoolProfileGroupType;

    @RelationList(() => SchoolProfileSectionEntityList)
    sections: SchoolProfileSectionEntity[];

    constructor(entity: Entity) {
        super(entity);

        this.type = entity?.type ?? SchoolProfileGroupType.summary;
    }
}

export { SchoolProfileGroupEntity };
